import React, { Component, Fragment } from "react";
import AutoInput from "../containers/AutoInput";
import withValues from "../hocs/withValues";
import { bindActionCreators } from "redux";

import { getValue, valueTypeAdapter } from "../utils/models";
import { Switch, Form, message } from "antd";
import moment from "moment";
import { connect } from "react-redux";
import { request } from "../utils/http";
import { getDispach } from "../modules/dispatch";
import custom from "../config/custom";
import _ from "lodash";

const formItemLayout = {
  labelCol: {
    xs: { span: 24 },
    sm: { span: 8 }
  },
  wrapperCol: {
    xs: { span: 24 },
    sm: { span: 10 }
  }
};

class DispatchEdit extends Component {
  constructor(props) {
    super(props);

    this.state = {
      customer: getValue(this.props.values, "customer"),
      customerQuery: "",
      vehicle: getValue(this.props.values, "vehicle"),
      vehicleQuery: "",
      vehicleType: getValue(this.props.values, "vehicletype"),
      vehicleTypeQuery: "",
      billType: getValue(this.props.values, "billType"),
      type: getValue(this.props.values, "type"),
      currency: getValue(this.props.values, "currency"),
      incremental: getValue(this.props.values, "incremental"),
      supplier: getValue(this.props.values, "supplier"),
      fetching: false,
      collectionTransitQuery: "",
      collectionTransit: getValue(this.props.values, "collectionTransit"),
      isLeasing: getValue(this.props.values, "isLeasing"),
      isCollection: getValue(this.props.values, "isCollection"),
      supplierCost: getValue(this.props.values, "supplierCost"),
      supplierExtraChargesCost: getValue(
        this.props.values,
        "supplierExtraChargesCost"
      )
    };
  }

  handleValue = () => {};

  componentDidUpdate(prevProps) {
    if (this.props.values.customer !== prevProps.values.customer) {
      this.setState({
        customer: getValue(this.props.values, "customer")
      });
    }

    if (this.props.values.vehicletype !== prevProps.values.vehicletype) {
      this.setState({
        vehicleType: getValue(this.props.values, "vehicletype")
      });
    }

    if (this.props.values.vehicle !== prevProps.values.vehicle) {
      this.setState({
        vehicle: getValue(this.props.values, "vehicle")
      });
    }

    if (this.props.values.billType !== prevProps.values.billType) {
      this.setState({
        billType: getValue(this.props.values, "billType")
      });
    }

    if (this.props.values.currency !== prevProps.values.currency) {
      this.setState({
        currency: getValue(this.props.values, "currency")
      });
    }

    if (this.props.values.incremental !== prevProps.values.incremental) {
      this.setState({
        incremental: getValue(this.props.values, "incremental")
      });
    }

    if (this.props.values.type !== prevProps.values.type) {
      this.setState({
        type: getValue(this.props.values, "type")
      });
    }

    if (this.props.values.supplier !== prevProps.values.supplier) {
      this.setState({
        supplier: getValue(this.props.values, "supplier")
      });
    }

    if (this.props.values.supplierCost !== prevProps.values.supplierCost) {
      this.setState({
        supplierCost: getValue(this.props.values, "supplierCost")
      });
    }

    if (
      this.props.values.supplierExtraChargesCost !==
      prevProps.values.supplierExtraChargesCost
    ) {
      this.setState({
        supplierExtraChargesCost: getValue(
          this.props.values,
          "supplierExtraChargesCost"
        )
      });
    }
  }

  componentWillReceiveProps(nextProps) {
    if (!this.state.type) {
      this.setState({ type: getValue(nextProps.values, "type") });
    }
  }

  getCustomerFilter() {
    let customerFilter = {
      or: [
        {
          id: this.state.customer
        }
      ]
    };

    if (this.state.customerQuery) {
      customerFilter.or = [
        ...customerFilter.or,
        {
          active: true,
          name: {
            contains: this.state.customerQuery
          }
        },
        {
          active: true,
          sapId: {
            contains: this.state.customerQuery
          }
        }
      ];
    }

    return customerFilter;
  }

  getVehicleFilter() {
    return {
      or: [
        {
          active: true,
          make: {
            contains: this.state.vehicleQuery
          }
        },
        {
          active: true,
          plateUsa: {
            contains: this.state.vehicleQuery
          }
        },
        {
          active: true,
          plateMx: {
            contains: this.state.vehicleQuery
          }
        }
      ]
    };
  }

  getVehicleTypeFilter() {
    return {
      or: [
        {
          active: true,
          name: {
            contains: this.state.vehicleTypeQuery
          }
        },
        {
          active: true,
          id: this.state.vehicleType
        }
      ]
    };
  }

  getTypeFilter() {
    let ids = [];

    switch (this.state.type) {
      case 4:
        ids = [1, 2];
        break;

      case 3:
        ids = [4];
        break;

      case 2:
        ids = [3, 5];
        break;

      default:
        break;
    }

    if (ids.length) {
      return {
        or: ids.map(id => ({ id }))
      };
    }

    return undefined;
  }

  getDispatchTypeFilter() {
    let dispatch_indicator = null;

    if (this.state.supplier)
      dispatch_indicator = this.state.supplier === 14 ? "FP" : "FS";

    let dispatchTypeFilter = {
      or: [
        {
          indicator: dispatch_indicator
        }
      ]
    };

    return dispatchTypeFilter;
  }

  getLeasingTransits() {
    return {
      isLeasing: true,
      collectionTransit: null
    };
  }

  handleConvertToCurrentCurrency(currency, supplierCost, exchangeRate) {
    if (currency === "MXN") {
      return supplierCost / exchangeRate;
    }

    return supplierCost * exchangeRate;
  }

  handleProfit(values) {
    const {
      amount,
      currency,
      supplierCost,
      supplierExtraChargesCost,
      charges
    } = values;

    const hasProfit = !!supplierCost;

    if (!hasProfit) return [false, 0];

    const exchangeRate = _.get(values, "exchangeRate", 1);
    const supplierCurrency = values.currency || "MXN";

    const supplierCostToCurrentCurrency =
      currency === supplierCurrency
        ? supplierCost
        : this.handleConvertToCurrentCurrency(
            supplierCurrency,
            supplierCost,
            exchangeRate
          );

    const chargesAmount = _.sumBy(charges || [], "amount");
    const total = amount + (chargesAmount || 0);

    const profit = hasProfit
      ? total - supplierCostToCurrentCurrency - (supplierExtraChargesCost || 0)
      : 0;

    return [hasProfit, profit];
  }

  render() {
    console.log(this.props.values);
    const [hasProfit, profit] = this.handleProfit(this.props.values);
    return (
      <Fragment>
        <AutoInput
          form={this.props.form}
          disabled={this.props.disabled}
          model={"dispatch"}
          id={this.props.id}
          autoSave
          attribute={"office"}
          filter={{ active: true }}
          value={getValue(this.props.values, "office")}
        />
        <AutoInput
          form={this.props.form}
          disabled={this.props.disabled}
          model={"dispatch"}
          id={this.props.id}
          autoSave
          attribute={"billType"}
          onChange={value => {
            this.setState({ billType: value });
          }}
          value={getValue(this.props.values, "billType")}
        />
        <AutoInput
          form={this.props.form}
          disabled={this.props.disabled}
          model={"dispatch"}
          id={this.props.id}
          autoSave
          attribute={"amount"}
          value={getValue(this.props.values, "amount")}
        />
        <AutoInput
          form={this.props.form}
          disabled={this.props.disabled}
          model={"dispatch"}
          id={this.props.id}
          autoSave
          attribute={"supplierCost"}
          value={getValue(this.props.values, "supplierCost")}
        />
        <AutoInput
          form={this.props.form}
          disabled={this.props.disabled}
          model={"dispatch"}
          id={this.props.id}
          autoSave
          attribute={"supplierExtraChargesCost"}
          value={getValue(this.props.values, "supplierExtraChargesCost")}
        />
        {hasProfit && (
          <AutoInput
            form={this.props.form}
            disabled
            model={"dispatch"}
            id={this.props.id}
            attribute={"profitability"}
            value={`$ ${profit}`}
          />
        )}
        <AutoInput
          form={this.props.form}
          disabled={this.props.disabled}
          model={"dispatch"}
          id={this.props.id}
          type={"model"}
          items={this.state.billType === 1 ? ["MXN", "USD"] : ["USD"]}
          autoSave
          attribute={"currency"}
          value={this.state.currency}
          onChange={value => {
            this.setState({ currency: value });
          }}
        />
        <AutoInput
          form={this.props.form}
          disabled={this.props.disabled}
          model={"dispatch"}
          id={this.props.id}
          autoSave
          attribute={"exchangeRate"}
          value={getValue(this.props.values, "exchangeRate")}
        />
        <AutoInput
          form={this.props.form}
          disabled={this.props.disabled}
          model={"dispatch"}
          id={this.props.id}
          autoSave
          attribute={"supplier"}
          value={getValue(this.props.values, "supplier")}
          onChange={value => {
            this.setState({ supplier: value });
          }}
        />
        <AutoInput
          form={this.props.form}
          disabled={this.props.disabled}
          model={"dispatch"}
          id={this.props.id}
          autoSave
          attribute={"type"}
          value={getValue(this.props.values, "type")}
          onChange={value => {
            if (value !== 1 && value !== 4) {
              this.setState({ incremental: undefined }, () => {
                request(
                  `${custom.baseUrl}/${this.props.model}/${this.props.id}`,
                  {
                    method: "PATCH",
                    data: { incremental: null }
                  }
                )
                  .then(() => {
                    //
                  })
                  .catch(() => {
                    //
                  });
              });
            }
            this.setState({ type: value }, () => {
              this.props.form.setFieldsValue({
                serviceType: value === 3 ? 4 : undefined
              });
              request(
                `${custom.baseUrl}/${this.props.model}/${this.props.id}`,
                {
                  method: "PATCH",
                  data: { serviceType: value === 3 ? 4 : null }
                }
              )
                .then(() => {
                  //
                })
                .catch(() => {
                  //
                });
            });
          }}
          filter={this.getDispatchTypeFilter()}
        />
        <AutoInput
          form={this.props.form}
          model={"dispatch"}
          id={this.props.id}
          autoSave
          attribute={"serviceType"}
          value={getValue(this.props.values, "serviceType")}
          filter={this.getTypeFilter()}
          required={[2, 3, 4].includes(this.state.type)}
          delayTime={100}
        />
        <AutoInput
          form={this.props.form}
          disabled={this.props.disabled}
          model={"dispatch"}
          id={this.props.id}
          autoSave
          attribute={"incremental"}
          value={this.state.incremental}
          hidden
        />
        <Form.Item
          style={{
            display:
              this.state.type && _.includes([1, 4], this.state.type)
                ? "block"
                : "none"
          }}
          label={"Para incrementables"}
          {...formItemLayout}
        >
          <Switch
            loading={this.state.fetching}
            disabled={this.props.disabled}
            onChange={async value => {
              let newValue = null;

              if (
                _.includes([1, 4], this.state.type) &&
                Boolean(this.state.incremental) !== value
              ) {
                if (value) {
                  let references = [];

                  this.setState({ fetching: true });

                  try {
                    const response = await request(
                      `${custom.baseUrl}/${this.props.model}/${
                        this.props.id
                      }/references`
                    );
                    references = response.data;
                  } catch (error) {
                    //
                  }

                  this.setState({ fetching: false });

                  if (
                    references.length &&
                    _.find(references, ref => ref.type && ref.type === 5)
                  ) {
                    this.setState({ incremental: moment() });
                    newValue = moment();
                  } else {
                    message.error("Debes agregar un pedimento como referencia");
                  }
                } else {
                  this.setState({ incremental: null });
                }
              }

              if (newValue) {
                request(
                  `${custom.baseUrl}/${this.props.model}/${this.props.id}`,
                  {
                    method: "PATCH",
                    data: valueTypeAdapter({ incremental: newValue })
                  }
                )
                  .then(() => {
                    //
                  })
                  .catch(() => {
                    //
                  });
              }
            }}
            checked={Boolean(this.state.incremental)}
          />
        </Form.Item>
        <AutoInput
          form={this.props.form}
          disabled={this.props.disabled}
          model={"dispatch"}
          id={this.props.id}
          autoSave
          attribute={"customer"}
          value={
            this.props.values.hasOwnProperty("customer") &&
            `${this.props.values.customer.sapId} ${
              this.props.values.customer.name
            }`
          }
          onSearch={value => {
            this.setState({ customerQuery: value });
          }}
          needFullValue
          onChange={values => {
            const { id } = JSON.parse(values);

            this.setState({ customer: id });
          }}
          placeholder={"Busca un cliente"}
          filter={this.getCustomerFilter()}
        />
        <AutoInput
          form={this.props.form}
          disabled={this.props.disabled}
          model={"dispatch"}
          id={this.props.id}
          autoSave
          attribute={"origin"}
          value={getValue(this.props.values, "origin")}
          filter={{ customer: this.state.customer }}
        />
        <AutoInput
          form={this.props.form}
          disabled={this.props.disabled}
          model={"dispatch"}
          id={this.props.id}
          autoSave
          attribute={"destination"}
          value={getValue(this.props.values, "destination")}
          filter={{ customer: this.state.customer }}
        />
        <AutoInput
          form={this.props.form}
          model={"dispatch"}
          id={this.props.id}
          autoSave
          attribute={"isLeasing"}
          value={getValue(this.props.values, "isLeasing")}
          disabled={this.state.isCollection}
          onChange={checked => this.setState({ isLeasing: checked })}
        />
        <AutoInput
          form={this.props.form}
          model={"dispatch"}
          id={this.props.id}
          autoSave
          attribute={"isCollection"}
          value={getValue(this.props.values, "isCollection")}
          disabled={this.state.isLeasing}
          onChange={checked => this.setState({ isCollection: checked })}
        />
        {(this.state.isCollection && (
          <AutoInput
            form={this.props.form}
            disabled={this.props.disabled}
            model={"dispatch"}
            id={this.props.id}
            autoSave
            ajax
            attribute={"collectionTransit"}
            value={getValue(this.props.values, "collectionTransit")}
            placeholder={"Ingrese el tránsito"}
            onSearch={value => {
              this.setState({ collectionTransitQuery: value });
            }}
            onChange={value => {
              this.setState({ collectionTransit: value });
            }}
            filter={this.getLeasingTransits()}
          />
        )) ||
          null}
        <AutoInput
          form={this.props.form}
          disabled={this.props.disabled}
          model={"dispatch"}
          id={this.props.id}
          autoSave
          attribute={"pickupCommitmentTime"}
          value={getValue(this.props.values, "pickupCommitmentTime")}
        />
        <AutoInput
          form={this.props.form}
          disabled={this.props.disabled}
          model={"dispatch"}
          id={this.props.id}
          autoSave
          attribute={"deliveryCommitmentTime"}
          value={getValue(this.props.values, "deliveryCommitmentTime")}
        />
        <AutoInput
          form={this.props.form}
          disabled={this.props.disabled}
          model={"dispatch"}
          id={this.props.id}
          autoSave
          ajax
          attribute={"vehicletype"}
          value={getValue(this.props.values, "vehicletype")}
          placeholder={"Ingrese el tipo de vehiculo"}
          onSearch={value => {
            this.setState({ vehicleTypeQuery: value });
          }}
          onChange={value => {
            this.setState({ vehicleType: value });
          }}
          filter={this.getVehicleTypeFilter()}
        />
        <AutoInput
          form={this.props.form}
          disabled={this.props.disabled}
          model={"dispatch"}
          id={this.props.id}
          autoSave
          ajax
          attribute={"vehicle"}
          value={getValue(this.props.values, "vehicle")}
          placeholder={"Ingrese el vehiculo"}
          onSearch={value => {
            this.setState({ vehicleQuery: value });
          }}
          onChange={value => {
            this.setState({ vehicle: value });
          }}
          filter={this.getVehicleFilter()}
        />
        <AutoInput
          form={this.props.form}
          disabled={this.props.disabled}
          model={"dispatch"}
          id={this.props.id}
          autoSave
          attribute={"economicNumber"}
          value={getValue(this.props.values, "economicNumber")}
        />
        <AutoInput
          form={this.props.form}
          disabled={this.props.disabled}
          model={"dispatch"}
          id={this.props.id}
          autoSave
          attribute={"trailerPlates"}
          value={getValue(this.props.values, "trailerPlates")}
        />
        <AutoInput
          form={this.props.form}
          disabled={this.props.disabled}
          model={"dispatch"}
          id={this.props.id}
          autoSave
          attribute={"driver"}
          value={getValue(this.props.values, "driver")}
        />
        <AutoInput
          form={this.props.form}
          model={"dispatch"}
          id={this.props.id}
          autoSave
          attribute={"comments"}
          value={getValue(this.props.values, "comments")}
        />
        <AutoInput
          form={this.props.form}
          model={"dispatch"}
          id={this.props.id}
          autoSave
          attribute={"customsRegime"}
          value={getValue(this.props.values, "customsRegime")}
        />
        <AutoInput
          form={this.props.form}
          model={"dispatch"}
          id={this.props.id}
          autoSave
          attribute={"supplierNumber"}
          value={getValue(this.props.values, "supplierNumber")}
        />
        <AutoInput
          form={this.props.form}
          model={"dispatch"}
          id={this.props.id}
          autoSave
          attribute={"operativeReferenceNumber"}
          value={getValue(this.props.values, "operativeReferenceNumber")}
        />
        <AutoInput
          form={this.props.form}
          model={"dispatch"}
          id={this.props.id}
          autoSave
          attribute={"containerNumber"}
          value={getValue(this.props.values, "containerNumber")}
        />
        <AutoInput
          form={this.props.form}
          model={"dispatch"}
          id={this.props.id}
          autoSave
          attribute={"boxNumber"}
          value={getValue(this.props.values, "boxNumber")}
        />
        <AutoInput
          form={this.props.form}
          model={"dispatch"}
          id={this.props.id}
          autoSave
          attribute={"uuidReference"}
          value={getValue(this.props.values, "uuidReference")}
        />

        <AutoInput
          form={this.props.form}
          model={"dispatch"}
          id={this.props.id}
          autoSave
          attribute={"isForwarder"}
          value={getValue(this.props.values, "isForwarder")}
        />
      </Fragment>
    );
  }
}

const mapStateToProps = state => ({
  record: state.dispatch.record
});

const mapDispatchToProps = dispatch =>
  bindActionCreators(
    {
      getDispach
    },
    dispatch
  );

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withValues(DispatchEdit));



// WEBPACK FOOTER //
// ./src/forms/DispatchEdit.js